import { computed } from 'vue'
import { defineStore } from 'pinia'
import { useLocalStorage } from '@vueuse/core'

export const useDebugStore = defineStore('settings/debug', () => {
  // State
  const debugPresentation = useLocalStorage<boolean>('settings/debug/debugPresentation', false)
  const debugSlide = useLocalStorage<boolean>('settings/debug/debugSlide', false)
  const debugSlideLayout = useLocalStorage<boolean>('settings/debug/debugSlideLayout', false)

  // Getters

  // Actions

  return {
    debugPresentation,
    debugSlide,
    debugSlideLayout
  }
})
